module.exports = __webpack_public_path__ + "static/media/collage-3.260db0ae.png";